import React, { useEffect, useState } from 'react';
import imgBLL from '../../../assets/images/logo-portais/logo-bll.png';
import imgBNC from '../../../assets/images/logo-portais/logo-bnc.png';
import imgComprasPublicas from '../../../assets/images/logo-portais/logo-portalcompraspublicas.svg';
import imgLicitanet from '../../../assets/images/logo-portais/logo-licitanet.svg';
import imgLicitarDigital from '../../../assets/images/logo-portais/logo-licitardigital.svg';

interface PartnerLogoProps {
  partnerSourceId: number;
}

interface PartnerLogoTypes {
  id: number;
  name: string;
  img: any;
}

const PartnerLogo = (props: PartnerLogoProps) => {
  const { partnerSourceId } = props;
  const [partnerLogo, setpartnerLogo] = useState<PartnerLogoTypes | undefined>(undefined);
  const partnersImages = [
    { id: 677, name: 'BLL Compras', img: imgBLL },
    { id: 857, name: 'Portal de Compras Públicas', img: imgComprasPublicas },
    { id: 3926, name: 'Bolsa Nacional de Compras', img: imgBNC },
    { id: 5204, name: 'Licitanet', img: imgLicitanet },
    { id: 6304, name: 'Licitar Digital', img: imgLicitarDigital },
  ];

  useEffect(() => {
    setpartnerLogo(partnersImages.find((partner) => partner.id === partnerSourceId));
  }, []);

  return (
    <div>
      {partnerLogo !== undefined ? (
        <div className="row">
          <div className="col-md-12 pull-right">
            <img
              src={partnerLogo.img}
              alt={partnerLogo.name}
              style={{ maxHeight: '32px', opacity: '0.4' }}
              className="float-right"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PartnerLogo;
